/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import SettingsWorkspaceIdentifiersBase from 'cio/components/settings/workspace-identifiers/base';

export default class SettingsWorkspaceIdentifiersEmail extends SettingsWorkspaceIdentifiersBase {
  @computed('args.editableEnvironment.identifierSettings.identify_by_id')
  get isIdentifyingById() {
    return this.args.editableEnvironment.identifierSettings.identify_by_id;
  }
}
